export default {
  payPeriods: [],
  payPeriodsLoading: false
}
